import "../global/basic.css"
import useBackupUser from "../shared/hooks/useBackupUser";
import useBackupGame from "../shared/hooks/useBackupGame";
import InactiveAnswerTable from "./InactiveAnswerTable";
import LabelledSwitch from "../shared/components/LabelledSwitch";
import { API_URL } from "../shared/api";
import MainComponent from "../global/mainlayout/MainComponent";
import { useCallback, useState } from "react";
import Dialog from "../shared/components/Dialog"
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { TOTAL_QUESTIONS } from "../shared/model/GameUtils";
import GameDetailStatsComponent from "./GameDetailStatsComponent"

export default function GameDetail() {
  const navigate = useNavigate();
  const user = useBackupUser()
  const game = useBackupGame();

  const openQuestions = useMemo(() => TOTAL_QUESTIONS - game?.stats.answeredQuestions, [game]);

  const handleActivateChange = useCallback((isSet) => {
    if(isSet) {
      fetch(`${API_URL}/users/${user?.id}/active-game`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: `"${game?.id}"`
      })
        .catch(e => console.error(e))
    } 
    else {
      fetch(`${API_URL}/users/${user?.id}/active-game`, { method: "DELETE" })
        .catch(e => console.error(e))
    }
  }, [game?.id, user?.id]);


  const [dialogOpen, setDialogOpen] = useState(false);

  const handleDeleteConfirm = useCallback(() => {
    setDialogOpen(false);
    fetch(`${API_URL}/users/${user?.id}/games/${game?.id}`, {method: "DELETE"})
      .catch(e => console.error(e))
      .then(() => navigate("./.."))
  }, [game?.id, user?.id, navigate])


  return (
    <MainComponent title={game?.name} useBackButton>

      <section className="section-container vertical-container padding">
        <div className="horizontal-container space-between">
          <LabelledSwitch label={"aktiviertes Spiel"} checkedColor="var(--primary-highlight-light)"
            onChange={handleActivateChange} initChecked={game?.isActive} />
          <span className="center default-light">
            {game?.stats.gameWon
            ? <span className="glow primary">Gewonnen!</span>
            : game?.stats.isCompleted
            ? "Beendet."
            : `${openQuestions} offene Fragen`}</span>
        </div>
        
        <InactiveAnswerTable game={game} />

        {!game?.stats.isCompleted 
          ? <span className="center">Verfügbare Joker: {game?.jokers}</span>
          : <GameDetailStatsComponent stats={game?.stats}/>
        }
      </section>

      <section className="center">
        <span onClick={setDialogOpen} className="error">Spiel löschen</span>
        <Dialog isOpen={dialogOpen} text={`Spiel "${game?.name}" wirklich löschen?`}
          onCancel={() => setDialogOpen(false)} onConfirm={handleDeleteConfirm} />
      </section>
      
    </MainComponent>
  );
}

